<template>
  <div class="page-view">
    <div class="scroll-view-wrapper exercise-question">
      <e-header
        title="我要提问"
        btnText="发布"
        :isXue="isXue"
        :disabled="disabled"
        @submit="submitContent"
      />

      <div class="title">
        <input
          type="text"
          v-model.trim="questionTitle"
          maxlength="20"
          placeholder="请输入标题"
        />
        <p class="text-length">
          <span :class="{ active: questionTitle.length > 0 }">{{
            questionTitle.length
          }}</span
          >/20
        </p>
      </div>

      <div class="textarea textarea-box">
        <textarea
          v-model.trim="content"
          maxlength="200"
          placeholder="请输入问题描述"
        ></textarea>
        <p class="text-num">
          <span :class="{ active: content.length > 0 }">{{
            content.length
          }}</span
          >/200
        </p>
      </div>

      <div class="question-upload-wrapper">
        <div
          class="question-upload-pic"
          v-for="(item, index) in images"
          :style="{ backgroundImage: 'url(' + item + ')' }"
          :key="index"
        >
          <div class="question-upload-delete" @click="deleteImage(index)"></div>
        </div>
        <div
          class="question-upload-button"
          v-show="images.length < 3"
          :class="{ 'question-upload-button-mt': images.length >= 3 }"
        >
          <i></i>
          <input type="file" @change="upload($event)" accept="image/*" />
        </div>
      </div>

      <div class="qustion-all">
        <div class="wrapper" @click="pageAction">
          <div class="text">查看所有问题</div>
          <div class="btn">
            <span>去看看</span>
            <i></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, computed } from 'vue'
import { exerReq } from '@/api'
import ImageUpload from '@hysfront/imageUpload'
import { api2 } from '@/public/utils/basePath'
import { createCommon } from '@/public/fetch/crypto'
import EHeader from '@/components/exercise/header/index.vue'
import { validateXue, hiddenAppNavBar, appPort } from '@/widget'
const isXue = validateXue()
const {
  proxy: { $showLoading, $hideLoading, $toast, $router }
} = getCurrentInstance()

const questionTitle = ref('')
const content = ref('')
const images = ref([])
const { currentRoute } = $router
const taskId = ref(currentRoute.value.query.taskId)
const disabled = computed(() => {
  return !questionTitle.value.length || !content.value.length
})
const upload = event => {
  const file = event.currentTarget.files[0]
  $showLoading()
  let data = Object.assign({}, createCommon())
  ImageUpload.start(file, {
    quality: '.8',
    url: `${api2}/v5/file/upload`,
    imageMinZoomWidth: 750,
    ext: true,
    data: data,
    onUpload: result => {
      $hideLoading()
      const data = result.data
      if (result.code === 200) {
        images.value.push(data)
      }
    }
  })
  event.target.value = ''
}

const deleteImage = index => {
  images.value.splice(index, 1)
}

const pageAction = () => {
  $router.push(`/exercise/question/list?id=${taskId.value}`)
}

const submitContent = async () => {
  if (!taskId.value) {
    $toast('id不存在')
    return
  }
  if (!questionTitle.value || !content.value) {
    return
  }
  const res = await exerReq.postAddQuiz({
    taskId: taskId.value,
    subject: questionTitle.value,
    description: content.value,
    files: images.value
  })
  if (Number(res.code) === 200) {
    questionTitle.value = ''
    content.value = ''
    images.value = []
    $toast('问题发布成功')
  } else {
    $toast(res.message)
  }
}
if (appPort()) {
  hiddenAppNavBar()
}
</script>

<style lang="scss" scoped>
@import '~@/components/exercise/style/default.scss';

.exercise-question {
  background-color: #fff;
  box-sizing: border-box;

  .text-length {
    color: #b1b1b3;
    font-size: 28px;
    position: absolute;
    span.active {
      color: #212224;
    }
  }

  .title {
    padding: 0 30px;
    margin-bottom: 32px;
    margin-top: 32px;
    position: relative;
    input {
      width: 100%;
      height: 88px;
      background-color: #f5f5f7;
      border-radius: 12px;
      padding: 20px 105px 20px 20px;
      box-sizing: border-box;
      font-size: 36px;
      color: #212224;
      border: none;
      &::-webkit-input-placeholder {
        color: #b1b1b3;
      }
      &:-moz-input-placeholder {
        color: #b1b1b3;
      }
      &:-ms-input-placeholder {
        color: #b1b1b3;
      }
      &::-moz-input-placeholder {
        color: #b1b1b3;
      }
    }
    p {
      top: 50%;
      right: 50px;
      transform: translateY(-50%);
    }
  }

  .textarea {
    padding: 0 30px;
    position: relative;
    margin-bottom: 32px;
    textarea {
      width: 100%;
      height: 316px;
      padding: 14px 16px 52px;
      box-sizing: border-box;
      background-color: #f5f5f7;
      border-radius: 12px;
      resize: none;
      border: none;
      font-size: 32px;
      line-height: 44px;
      color: #212224;
      &::-webkit-input-placeholder {
        color: #b1b1b3;
      }
      &:-moz-input-placeholder {
        color: #b1b1b3;
      }
      &:-ms-input-placeholder {
        color: #b1b1b3;
      }
      &::-moz-input-placeholder {
        color: #b1b1b3;
      }
    }
    p {
      right: 50px;
      bottom: 10px;
    }
  }
  .textarea-box {
    padding: 0 0 10px;
    margin: 0 30px 32px;
    background-color: #f5f5f7;
    textarea {
      padding: 14px 16px 0;
    }
    .text-num {
      color: #b1b1b3;
      font-size: 28px;
      text-align: right;
    }
  }

  .question-upload-wrapper {
    // width: 7.2rem;
    padding: 0 30px;
    margin-bottom: 42px;
    display: flex;
    flex-wrap: wrap;
  }
  .question-upload-pic {
    width: 160px;
    height: 160px;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 12px;
    position: relative;
    .question-upload-delete {
      width: 32px;
      height: 32px;
      background: url('~@/components/exercise/img/upload_delete_icon.png')
        no-repeat;
      background-size: 100% auto;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
  .question-upload-button {
    width: 160px;
    height: 160px;
    background-color: #f5f5f7;
    border-radius: 8px;
    position: relative;
    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 82px;
      background: url('~@/components/exercise/img/question_upload_bg.png')
        no-repeat;
      background-size: 100% auto;
    }
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      filter: alpha(opacity=0);
    }
  }
  .question-upload-button-mt {
    margin-top: 0.28rem;
  }

  .qustion-all {
    padding: 0 30px;
    .wrapper {
      padding: 28px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 2px solid #f0f0f0;
      border-bottom: 2px solid #f0f0f0;
      .text {
        color: #212224;
        font-size: 30px;
      }
      .btn {
        display: flex;
        align-items: center;
        span {
          color: #969799;
          font-size: 32px;
        }
        i {
          display: inline-block;
          margin-left: 4px;
          width: 24px;
          height: 24px;
          background-image: url('~@/components/exercise/img/question_all_icon.png');
          background-size: cover;
        }
      }
    }
  }
}
</style>
